class PageLands {
    constructor() {

        this.searchBar = document.querySelector('.land-search-bar');
        if( !this.searchBar ){
            return;
        }
        this.formInit();

        this.mapContainer = document.querySelector('.land-map');
        if( this.mapContainer ){
            this.buildMap();
            resizeCallbacks.push(this);
        }

    }

    formInit(){


        this.form = this.searchBar.querySelector('.land-search-form');
        let inputRange = this.form.querySelectorAll('.land-search-field--range');
        const inputRangeValues = [0, 5, 10, 20, 30, 50];

        inputRange.forEach( (field) => {
            let range = field.querySelector('input[type="range"]');
            let input = field.querySelector('input[type="hidden"]');
            let distance = field.querySelector('.land-search-distance');

            let value = 0;
            inputRangeValues.forEach( (v, key) => {
                if( v === parseInt(input.value) ){
                    value = key;
                }
            });
            range.value = value;
            range.style.backgroundSize = this.backgroundColor(range);
            distance.innerHTML = inputRangeValues[range.value] + " km";

            range.addEventListener("input", () => {
                range.style.backgroundSize = this.backgroundColor(range);
                distance.innerHTML = inputRangeValues[range.value] + " km";
                input.value = inputRangeValues[range.value];
            });

        });

        const input = this.form.querySelector("input[name='location']");
        const coordinate = this.form.querySelector("input[name='coordinate']");

        input.addEventListener("focus", () => {
            const options = {
                componentRestrictions: {country: 'fr'}
            };
            const searchBox = new google.maps.places.Autocomplete(input, options);
            searchBox.addListener("place_changed", (e) => {
                const places = searchBox.getPlace();
                if (places.length === 0) {
                    return;
                }
                coordinate.value = places.geometry.location.lat() + ',' + places.geometry.location.lng();
            });
        });

        input.addEventListener("blur", () => {
            if( input.value === "" ){
                coordinate.value = "";
            }
        });

        this.headerHeight = document.querySelector('.header-main').offsetHeight;
        ScrollTrigger.create({
            trigger : this.searchBar,
            start: "bottom top+=" + this.headerHeight+"px",
            end: 99999,
            toggleClass: {
                targets: ".mobile-search-modify",
                className: "visible"
            }
        });

        gsap.set('.mobile-search-modify.is-sticky',{
            top: this.headerHeight + "px"
        });

        let modifySearchBtn = document.querySelectorAll('.mobile-search-modify');
        modifySearchBtn.forEach( (btn) => {
            btn.addEventListener('click', () => {
                this.extendList();
                document.body.classList.remove('main-map-open');
                window.scrollTo({
                    top: document.querySelector('.banner-default').offsetHeight - this.headerHeight,
                    behavior: "smooth"
                });
            });
        });

    }

    backgroundColor(input){

        const min = input.min;
        const max = input.max;
        const currentVal = input.value;
        return ((currentVal - min) / (max - min)) * 100 + "% 100%";

    }

    buildMap(){
        this.landList = document.querySelector('.land-list');
        this.mapInner = this.mapContainer.querySelector('.inner-map');
        this.pinMap();
        this.buildArrows();
        this.loadMap();
    }

    pinMap() {

        this.headerHeight = document.querySelector('.header-main').offsetHeight;
        if (!this.mapContainer || mobileCheck.isMobile) {
            return;
        }
        if (this.mapPin) {
            this.mapPin.disable(true);
            this.mapPin.kill();
        }
        if (window.innerWidth > 991) {
            this.mapContainer.style.height = (window.innerHeight - this.headerHeight) + "px";
            this.landList.style.minHeight = (window.innerHeight - this.headerHeight) + "px";
        }
        setTimeout(() => {
            ScrollTrigger.matchMedia({
                "(min-width: 992px)": () => {
                    setTimeout(() => {
                        this.mapPin = ScrollTrigger.create({
                            trigger: this.searchBar,
                            start: "top top+=" + this.headerHeight,
                            anticipatePin: true,
                            endTrigger: this.landList,
                            end: 'bottom bottom',
                            pinSpacing: false,
                            pin: this.mapContainer
                        });
                    }, 0);
                }
            });
        }, 0);
    }

    buildArrows() {
        this.currentState = "extendedList";
        let toggleMap = document.querySelectorAll('.toggle-map');
        let toggleList = document.querySelectorAll('.toggle-list');

        toggleList.forEach(btn => {
            btn.addEventListener('click', () => {
                if (window.innerWidth > 991) {
                    this.extendList();
                }
                document.body.classList.remove('main-map-open');
            });
        });

        toggleMap.forEach(btn => {
            btn.addEventListener('click', () => {
                if (window.innerWidth > 991) {
                    this.extendMap();
                }
                document.body.classList.add('main-map-open');
            });
        });
    }

    extendMap() {
        this.currentState = "extendedMap";
        gsap.to(this.landList, {
            x: 150,
            opacity: 0,
            duration: 0.1
        });
        gsap.to(this.mapInner, {
            width: window.innerWidth - (window.innerWidth - document.documentElement.clientWidth),
            duration: 0.3
        });
    }

    extendList() {
        this.currentState = "extendedList";
        gsap.to(this.landList, {
            x: 0,
            opacity: 1,
            duration: 0.3
        });
        gsap.to(this.mapInner, {
            width: this.mapContainer.offsetWidth,
            duration: 0.2
        });
    }

    loadMap() {
        this.bounds = new google.maps.LatLngBounds();
        this.places = document.querySelectorAll('.map-marker');
        this.mapView = this.mapContainer.querySelector('.map');
        this.btnEnlarge = document.querySelector('.map-enlarge');
        this.counters = document.querySelectorAll('.counters');
        this.markers = [];

        let centerMap = new google.maps.LatLng(45.619722, 4.6730292);

        this.map = new google.maps.Map(this.mapView, {
            center: centerMap,
            zoom: 10,
            clickableIcons: false,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            zoomControl: false,
            gestureHandling: "cooperative",
            mapId: "6ff68edf5d1d30ef"
        });

        this.overlays = [];
        this.cards = [];
        this.places.forEach((place) => {
            let id = place.dataset.id;
            let lat = place.dataset.lat;
            let lng = place.dataset.lng;
            let label = place.dataset.label;
            let type = place.dataset.type;
            let contentString = place.innerHTML;
            let text = label === "0" ? "Découvrir" : label + " €";

            if (!lat) {
                return;
            }

            let marker = new google.maps.marker.AdvancedMarkerElement({
                map: this.map,
                zIndex: 0,
                content: place.querySelector('.map-marker-inner'),
                position: {
                    lat: parseFloat(lat),
                    lng: parseFloat(lng)
                }
            });

            marker.addListener("click", () => {
                if( this.markerIsView ){
                    this.markerIsView.content.classList.remove('view');
                }
                if( this.markerIsView === marker ){
                    this.markerIsView = null;
                    return;
                }
                this.markers.forEach( (m) => {
                    m.zIndex = 0;
                });
                marker.content.classList.toggle('view');
                marker.zIndex = 9999;
                this.markerIsView = marker;
            });

            this.cards[id] = place.closest('.card-land');
            this.markers.push(marker);
            this.bounds.extend(marker.position);

            let card = place.closest('.card-land');
            if (card) {
                card.addEventListener('mouseenter', (c) => {
                    this.cardHover('enter', id);
                });
                card.addEventListener('mouseleave', (c) => {
                    this.cardHover('leave', id);
                });
            }
        });

        this.zoomControls();

        let coordinate = this.form.querySelector('input[name="coordinate"]');
        let distance = this.form.querySelector('input[name="distance"]');
        if( coordinate.value !== "" ){
            let center = coordinate.value.split(',');
            this.map.setCenter(new google.maps.LatLng(center[0], center[1]));
            this.areaCircle = new google.maps.Circle({
                strokeColor: "#634D3F",
                strokeOpacity: 0.5,
                strokeWeight: 1,
                fillColor: "#634D3F",
                fillOpacity: 0.15,
                map: this.map,
                center: new google.maps.LatLng(center[0], center[1]),
                radius: distance.value * 1000
            });
        } else if (this.markers.length > 1) {
            this.map.fitBounds(this.bounds);
        }

        google.maps.event.addListener(this.map, 'idle',
            debounce(this.markerInViewUpdate.bind(this))
        );

    }

    cardHover(event, id) {
        if (event === "enter") {
            this.markers.forEach((marker) => {
                if (marker.content.dataset.id === id) {
                    marker.content.classList.add('isHover');
                    return false;
                }
            });
        } else {
            this.markers.forEach((marker) => {
                marker.content.classList.remove('isHover');
            });
        }
    }

    zoomControls() {
        let zoomIn = document.querySelector('.map-zoom-in');
        if (zoomIn) {
            zoomIn.addEventListener('click', () => {
                this.map.setZoom(this.map.getZoom() + 1);
            });
        }

        let zoomOut = document.querySelector('.map-zoom-out');
        if (zoomOut) {
            zoomOut.addEventListener('click', () => {
                this.map.setZoom(this.map.getZoom() - 1);
            });
        }

        this.btnEnlarge.addEventListener('click', () => {
            this.map.setZoom(this.map.getZoom() - 1);
        });
    }

    markerInViewUpdate(){
        let visibleMarkers = [];
        let bounds = this.map.getBounds();
        if( this.areaCircle ){
            bounds = this.areaCircle.getBounds();
        }

        this.markers.forEach((marker) => {
            if( bounds.contains(marker.position) === true ) {
                visibleMarkers.push(marker);
                this.cards[ marker.content.dataset.id ].classList.remove('d-none');
            } else {
                this.cards[ marker.content.dataset.id ].classList.add('d-none');
                marker.content.classList.remove('view');
                if( marker === this.markerIsView ){
                    this.markerIsView = null;
                }
            }
        });

        this.counters.forEach( (counter) => {
           counter.classList.add('d-none');
           if( counter.querySelector('.count') ) {
              counter.querySelector('.count').innerHTML = visibleMarkers.length;
           }
        });

        if( visibleMarkers.length === 0 ){
            // this.btnEnlarge.classList.remove('d-none');
            document.querySelector('.counters.no-result').classList.remove('d-none');
        } else if ( visibleMarkers.length === 1 ) {
            // this.btnEnlarge.classList.add('d-none');
            document.querySelector('.counters.one-result').classList.remove('d-none');
        } else{
            // this.btnEnlarge.classList.add('d-none');
            document.querySelector('.counters.multi-result').classList.remove('d-none');
        }

    }

    resize() {

        gsap.set('.mobile-search-modify',{
            top: this.headerHeight + "px"
        });

        this.pinMap();
        if( this.currentState === "extendedMap" && window.innerWidth > 991 ){
            console.log("ici");
            gsap.to(this.mapInner, {
                width: window.innerWidth - (window.innerWidth - document.documentElement.clientWidth)
            });
        } else {
            gsap.to(this.mapInner, {
                width: this.mapContainer.offsetWidth
            });
        }
    }

}

function debounce(func) {
    let timer;
    return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, 100, event);
    };
}